export type ImageFormat = 'jpeg' | 'png'

/**
 * Encodes a canvas to a Blob using toBlob().
 * For JPEG, a quality parameter is applied (default 0.95).
 * PNG is lossless — no quality parameter.
 */
export function encodeImage(
  canvas: HTMLCanvasElement,
  format: ImageFormat,
  quality?: number,
): Promise<Blob> {
  const type = format === 'jpeg' ? 'image/jpeg' : 'image/png'
  const q = format === 'jpeg' ? quality ?? 0.95 : undefined

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob)
        else reject(new Error(`Failed to encode canvas as ${type}`))
      },
      type,
      q,
    )
  })
}
